import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Contact from './../components/Contact'

class ContactContainer extends Component {
  handleClickBack = () => {
    this.props.history.goBack()
  }
  handleClickSend = () => {
    console.log(this.props)
  }
  render () {
    return (
      <div className='container'>
        <Contact handleClickBack={this.handleClickBack} isLogin={this.props.isLogin} />
      </div>
    )
  }
}

export default withRouter(ContactContainer)



// WEBPACK FOOTER //
// ./src/containers/ContactContainer.js